import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';

import SalonModal from 'components/dialog/SalonModal.component';
import SM from 'components/dialog/SalonModal.module.scss';
import Button from 'components/form/Button.component';
import IconStatus from 'components/generic/IconStatus.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './ModalGoOffline.module.scss';

export const ModalGoOffline = ({ isOpen, onConfirm, onDiscard, message, onClose }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="ModalGoOffline-modal" isOpen={isOpen}>
      <SalonModal.Header>
        <div className={SM.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <XMarkIcon />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <IconStatus variant="alert" width="lg">
          <ExclamationTriangleIcon className={CN.alertIcon} />
        </IconStatus>
        <div className={SM.modalContent}>
          <div className={SM.modalTitle}>{t('onlineBooking.generalSettings.confirmationModal.title')}</div>
          <div className={SM.modalText}>{message}</div>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="outlineForce" onClick={onDiscard} xSpace>
          {t('onlineBooking.generalSettings.confirmationModal.discardButton')}
        </Button>
        <Button variant="primaryForce" onClick={onConfirm} xSpace>
          {t('onlineBooking.generalSettings.confirmationModal.confirmButton')}
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};
